import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { boot } from './boot';
import './styles.css';

/**
 * The entry point, and nothing else lives here.
 *
 * The boot sequence moved to boot.ts so it could be tested: this file cannot
 * be imported without mounting the app into a #root that only index.html has.
 *
 * boot() is not awaited and never rejects — it writes its own outcome, boot
 * errors included, into the store. React mounts immediately and paints the
 * 'boot' screen; the API client and the media resolver read the runtime config
 * from a module holder rather than props, and every screen that needs one is
 * behind a screen change that boot() makes only after the config is set.
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

void boot();
